import styled from "styled-components";

const backgroundColor = "#000";
const opacity = props => (props.isTinted ? 0.5 : 0);
const pointerEvents = props => (props.canClickThrough ? "none" : "initial");

export default styled.div`
  background: ${backgroundColor};
  bottom: 0;
  left: 0;
  opacity: ${opacity};
  pointer-events: ${pointerEvents};
  position: fixed;
  right: 0;
  top: 0;
  transition: opacity 220ms;
  z-index: 0;
`;
